import type { ServiceModuleInterface } from '@src/domain/types';
import type { ServiceModuleApiInterface } from '@src/server';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';

const transformFromApiModel = (apiModel: ServiceModuleApiInterface[]): ServiceModuleInterface[] =>
  apiModel.map((modelContent) => {
    const { name, description, inputs, url } = modelContent.attributes;
    const [provider, ...title] = name.split('-');

    return {
      id: modelContent.id,
      title: title.join('-'),
      inputs,
      provider,
      description,
      url,
      deploysServiceModule: true,
    };
  });

export const ServiceModuleMapper: MapperInterface<
  ServiceModuleInterface[],
  ServiceModuleApiInterface[]
> = { transformFromApiModel };
